module.exports = __webpack_public_path__ + "media/Werbung_Max_Factor.1db3f902.mp3";